import React from "react";

/**
 * Конфигурация фронта
 */
export interface UISettingsInterface  {
  /**
   * Отображаемое наименование на страницах:
   *  регистрации/авторизации/хедере лайаутов и письмах.
   */
  name: string,
  /**
   * Отображаемое наименование титула страницы у фавикона вкладки (document.title)
   */
  title: string
  /**
   * Используется на странице авторизации/регистрации юзера и письмах.
   * Так же в хедере основного лайаута, если не указан logoSmall в конфигурации
   */
  logo: string,
  /**
   * Изображение иконки (favicon) во вкладке браузера
   */
  favicon: string
  /**
   * Используется в хедере основного лайаута.
   * По дефолту - используется logo
   */
  logoSmall?: string,
}

const UISettingsContext = React.createContext<UISettingsInterface>({} as UISettingsInterface);

export default UISettingsContext;
